import { pxToRem } from '@archipro-design/aria';
import type { StyleRule } from '@archipro-design/aria';
import type { RGB } from '@modules/paint-picker-new/type';
import { APPEAR_ANIMATION_DURATION } from '@modules/paint-picker-new/config';

export const Container: StyleRule<{
    rgb: RGB;
}> = ({ rgb }) => ({
    position: 'relative',
    width: pxToRem(73),
    height: pxToRem(73),
    backgroundColor: `rgb(${rgb.r}, ${rgb.g}, ${rgb.b})`,
    border: '2px solid #000',
    borderRadius: '50%',
    overflow: 'hidden',
    flexShrink: 0,
});

export const Colour: StyleRule<{
    frame: string;
}> = ({ frame }) => ({
    width: '100%',
    height: '100%',
    backgroundSize: 'cover',
    position: 'relative',

    '&::after': {
        content: '""',
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        backgroundImage: `url(${frame})`,
        backgroundSize: 'contain',
        zIndex: 1,
    },
});

export const colourAnimation = {
    open: {
        width: pxToRem(73),
        height: pxToRem(73),
        borderWidth: '2px',
        transition: { duration: APPEAR_ANIMATION_DURATION },
    },
    closed: {
        width: [null, pxToRem(26), pxToRem(26)],
        height: [null, pxToRem(26), pxToRem(26)],
        borderWidth: '1px',
        transition: { duration: APPEAR_ANIMATION_DURATION },
    },
};
